import React from "react";
import { isSafari } from "@clientUtils";
import { DnDContext, DropListener } from "./DnDContext";
import DnDOverlay, { DnDOverlayProps } from "./components/DnDOverlay";
import { omit } from "@bonliva-crm/common";

type Props = {
  className?: string;
  children?: React.ReactNode;
  disabled?: boolean;
  onDrop: DropListener;
  overlayProps?: Partial<DnDOverlayProps>;
  style?: React.CSSProperties;
};

/**
 * you probably want to use DnDLocalContainer
 */
const DnDContainer: React.FC<Props> = (props) => {
  return (
    <DnDContext.Consumer>
      {(dndCtx) => {
        if (!dndCtx || !dndCtx.dzProps) {
          return <div className={props.className}>{props.children}</div>;
        }

        dndCtx.listen(!props.disabled ? props.onDrop : null);

        const isActive =
          !props.disabled &&
          dndCtx.dzProps.isDragActive &&
          dndCtx.listener === props.onDrop;

        const isAccepted = isSafari() ? true : dndCtx.dzProps.isDragAccept;

        const rootProps = omit(dndCtx.dzProps.getRootProps(), "onClick", "onKeyDown");

        return (
          <div
            {...rootProps}
            className={props.className}
            data-test="DnDContainer"
            style={{ position: "relative", outline: "none", ...props.style }}
          >
            {isActive && (
              <DnDOverlay
                type={isAccepted ? "accept" : "reject"}
                accept={dndCtx.accept}
                {...props.overlayProps}
              />
            )}
            {props.children}
          </div>
        );
      }}
    </DnDContext.Consumer>
  );
};

export default DnDContainer;
